import sendMail from "./teacher-send";

export default function teacherForm() {

  const validateName = (name) => {
    if (name.length >= 2 && name.length < 50) {
      return name.match(
        /^[а-яА-Яa-zA-Z]/
      );
    }
  }

  const validatedName = function() {
    const name = $(this).val();

    if (validateName(name)) {
      $(this).removeClass('not-valid').addClass('filled');
    } else {
      $(this).addClass('not-valid').addClass('filled');
    }
    if (name == '') {
      $(this).removeClass('not-valid').removeClass('filled');
    }
    return false;
  }

  $('input[name="name"]').on('input', function() {
    validatedName.call(this);
  });

  function sendTeacherForm() {
    let form = $('.teacher__form__container');
    let button = $('.teacher__form__container').find('button[type="submit"]');
    let timer = 0;
    button.on('click', function() {
      Array.from($('input')).forEach(function(input) {
        if ($(input).val() == '') {
          $(input).addClass('not-valid');
        } else {
          $(input).removeClass('not-valid');
        }
      });
    });
    if (form) {
      form.on('submit', function(e) {
        e.preventDefault();
        if (
          !$('input[name="comment"]').hasClass('not-valid')) {
          sendMail(form).then(function() {
            button.parent().get(0).reset();
            $('input').removeClass('not-valid');
            $('input').removeClass('filled');
            button.text('Отправлено!')
            timer = setTimeout(function() {
              button.text('Оставить отзыв')
              clearTimeout(timer);
            }, 2000);
          });
        }
      });
    }
  }
  sendTeacherForm();

}
teacherForm();
